import React from "react";

const List = (props) => {
    const {data} = props
    return (
        <ul>
            {data?.map((objective, index) =>  (
                <li key={index}>
                    {objective}
                </li>
            ))}
        </ul>
    );
};

export default List;
